
export default {
  summary: {
    title: '¡Operación Exitosa!',
    workshop_cost: 'Costo de la valoración',
    your_balance: 'Su saldo',
    token_unit: 'OCC Tokens',
    information: 'Si desea adquirir más OCC Tokens diríjase a Operaciones de Suite',
    get_more_tokens: 'Adquirir más OCC Tokens',
    or: 'Ó',
    go_to_evaluations_list: 'Ir al Listado de valoraciones'
  }
}
